
import { Component, Prop, Vue } from 'vue-property-decorator';

//@ts-ignore
import Glider from 'glider-js';

@Component
export default class CarouselV extends Vue {
    @Prop() section!: any;
    @Prop() index!: number;

    mounted() {
        new Glider(this.$el.querySelector('.glider'), {
            slidesToShow: 1,
            scrollLock: true,
            scrollLockDelay: 0,
            dots: '.dots',
            draggable: true
        });
    }
}
